import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import AdminPanelLogin from "./AdminPanelLogin";
import AdminPanelView from "./AdminPanelView";

function AdminPanel() {
    const [user, setUser] = useState([]);

    function loginUser(val) {
        setUser(val);
    }

    return (
        <div>
            {user.length === 0 ? <AdminPanelLogin loginUser={loginUser} /> : <AdminPanelView />}
        </div>
    );
}

export default AdminPanel;

if (document.getElementById("AdminPanel")) {
    ReactDOM.render(<AdminPanel />, document.getElementById("AdminPanel"));
}
